<header
  class="header-app sticky top-0 flex w-full bg-white border-gray-200 z-99999 dark:border-gray-800 dark:bg-gray-900 xl:border-b transition-all duration-300 ease-in-out">
  <div class="flex flex-col items-center justify-between grow xl:flex-row xl:px-6">
    <div
      class="flex items-center justify-between w-full gap-2 px-3 py-3 border-b border-gray-200 dark:border-gray-800 sm:gap-4 xl:justify-normal xl:border-b-0 xl:px-0 lg:py-4">
      <button
        class="items-center justify-center w-10 h-10 text-gray-500 border-gray-200 rounded-lg z-99999 dark:border-gray-800 flex dark:text-gray-400 lg:h-11 lg:w-11 xl:border transition-all duration-200 hover:bg-gray-100 dark:hover:bg-white/[0.05]"
        [ngClass]="{
          'bg-gray-100 dark:bg-white/[0.03]': isMobileOpen() || isExpanded()
        }"
        (click)="handleToggle()" 
        [attr.aria-label]="isExpanded() ? 'Colapsar Sidebar' : 'Expandir Sidebar'"
        [title]="isExpanded() ? 'Colapsar menú lateral' : 'Expandir menú lateral'">
        
        <!-- MÓVIL: Usar solo isMobileOpen$ -->
        <span class="xl:hidden">
          @if (isMobileOpen()) {
            <!-- Cross Icon -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
                fill="currentColor" />
            </svg>
          } @else {
            <!-- Hamburger Icon -->
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                fill="currentColor" />
            </svg>
          }
        </span>

        <!-- DESKTOP: Usar solo isExpanded$ -->
        <span class="hidden xl:block">
          @if (isExpanded()) {
            <!-- Cross Icon -->
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
                fill="currentColor" />
            </svg>
          } @else {
            <!-- Hamburger Icon -->
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M0.583252 1C0.583252 0.585788 0.919038 0.25 1.33325 0.25H14.6666C15.0808 0.25 15.4166 0.585786 15.4166 1C15.4166 1.41421 15.0808 1.75 14.6666 1.75L1.33325 1.75C0.919038 1.75 0.583252 1.41422 0.583252 1ZM0.583252 11C0.583252 10.5858 0.919038 10.25 1.33325 10.25L14.6666 10.25C15.0808 10.25 15.4166 10.5858 15.4166 11C15.4166 11.4142 15.0808 11.75 14.6666 11.75L1.33325 11.75C0.919038 11.75 0.583252 11.4142 0.583252 11ZM1.33325 5.25C0.919038 5.25 0.583252 5.58579 0.583252 6C0.583252 6.41421 0.919038 6.75 1.33325 6.75L7.99992 6.75C8.41413 6.75 8.74992 6.41421 8.74992 6C8.74992 5.58579 8.41413 5.25 7.99992 5.25L1.33325 5.25Z"
                fill="currentColor" />
            </svg>
          }
        </span>
      </button>
      <!-- Logo de la empresa: enlaza al detalle de la empresa seleccionada (si el usuario puede verla) -->
      <div class="general-company">
        <div class="general-company-left">
          @if (companyDetailLink(); as detailLink) {
            <a [routerLink]="detailLink" class="cursor-pointer"
               title="Ver detalle de la empresa seleccionada"
               aria-label="Ver detalle de la empresa seleccionada">
              <img class="image-logo-selected-company dark:hidden" [src]="imgLogo()" alt="Logo de la empresa" />
              <img class="image-logo-selected-company-dark hidden dark:block" [src]="imgLogo()" alt="Logo de la empresa" />
            </a>
          } @else {
            <span>
              <img class="image-logo-selected-company dark:hidden" [src]="imgLogo()" alt="Logo de la empresa" />
              <img class="image-logo-selected-company-dark hidden dark:block" [src]="imgLogo()" alt="Logo de la empresa" />
            </span>
          }
        </div>
        <div class="general-company-right">
          <app-select-search
            [datalist]="companyOptions()"
            [ngModel]="selectedCompany()"
            [behaveAsSelect]="true"
            (ngModelChange)="onCompanySelected($event)"
            placeholder="Seleccione su Empresa"
          ></app-select-search>
        </div>
        @if (publicStorePath(); as storePath) {
          <a [href]="storePath"
             target="_blank"
             rel="noopener noreferrer"
             class="ml-1 hidden shrink-0 items-center gap-1.5 rounded-lg border border-brand-500/30 bg-brand-50 px-3 py-2 text-sm font-medium text-brand-700 hover:bg-brand-100 dark:border-brand-400/30 dark:bg-brand-500/10 dark:text-brand-300 dark:hover:bg-brand-500/20 sm:inline-flex"
             title="Abrir la tienda pública en una nueva pestaña"
             aria-label="Ver tienda pública">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
            </svg>
            Ver tienda
          </a>
        }
      </div>
      <button (click)="toggleApplicationMenu()"
        class="flex items-center justify-center w-10 h-10 text-gray-700 rounded-lg z-99999 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800 xl:hidden">
        <!-- Dots Icon -->
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M5.99902 10.4951C6.82745 10.4951 7.49902 11.1667 7.49902 11.9951V12.0051C7.49902 12.8335 6.82745 13.5051 5.99902 13.5051C5.1706 13.5051 4.49902 12.8335 4.49902 12.0051V11.9951C4.49902 11.1667 5.1706 10.4951 5.99902 10.4951ZM17.999 10.4951C18.8275 10.4951 19.499 11.1667 19.499 11.9951V12.0051C19.499 12.8335 18.8275 13.5051 17.999 13.5051C17.1706 13.5051 16.499 12.8335 16.499 12.0051V11.9951C16.499 11.1667 17.1706 10.4951 17.999 10.4951ZM13.499 11.9951C13.499 11.1667 12.8275 10.4951 11.999 10.4951C11.1706 10.4951 10.499 11.1667 10.499 11.9951V12.0051C10.499 12.8335 11.1706 13.5051 11.999 13.5051C12.8275 13.5051 13.499 12.8335 13.499 12.0051V11.9951Z"
            fill="currentColor" />
        </svg>
      </button>
    </div>
    <div [ngClass]="isApplicationMenuOpen() ? 'flex' : 'hidden'"
      class="items-center justify-between w-full gap-4 px-5 py-4 xl:flex shadow-theme-md xl:justify-end xl:px-0 xl:shadow-none">
      @if (publicStorePath(); as storePath) {
        <a [href]="storePath"
           target="_blank"
           rel="noopener noreferrer"
           class="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-brand-500/30 bg-brand-50 px-4 py-2.5 text-sm font-medium text-brand-700 hover:bg-brand-100 dark:border-brand-400/30 dark:bg-brand-500/10 dark:text-brand-300 dark:hover:bg-brand-500/20 xl:hidden"
           aria-label="Ver tienda pública">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
          Ver tienda pública
        </a>
      }
      <div class="flex items-center gap-2 2xsm:gap-3">
        <!-- ThemeToggleButton placeholder -->
        <app-theme-toggle-button />
        <!-- Ticketera de esta PC (solo si está registrada como estación de impresión) -->
        <app-print-station-indicator />
        <!-- NotificationDropdown placeholder -->
        <app-notification-icon />
      </div>
      <!-- UserDropdown placeholder -->
      <app-user-dropdown />
    </div>
  </div>
</header>
